/**
 * Coercition d'une valeur Decimal sérialisée par l'API vers un `number` sûr.
 *
 * Doctrine _INTRO §Conventions : les `Decimal` Pydantic arrivent en STRING JSON
 * ASCII (« 100000.00 » — jamais de séparateur de milliers ni de virgule
 * décimale). On accepte donc `number | string | null | undefined` et on renvoie
 * `null` pour toute valeur absente ou non finie.
 */
export function coerceToNumber(v: number | string | null | undefined): number | null {
    if (v == null) return null
    if (typeof v === 'number') return Number.isFinite(v) ? v : null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
}
